/* eslint no-console: 0 */

// require("@rails/ujs").start()
// require("@rails/activestorage").start()
// require("channels")

import Vue from 'vue'
import ActionCableVue from 'actioncable-vue';
import Chat from '../chat.vue'
import ChatStart from '../chat_start.vue'
Vue.component('ChatStart', ChatStart)

// import "../css/application.css"
// window.Rails = Rails

import VeeValidate from'vee-validate'
Vue.use(VeeValidate);

import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)

import MaskedInput from 'vue-text-mask'
Vue.use(MaskedInput);

import store from '../chat_store'
const event = (typeof Turbolinks == "object" && Turbolinks.supported) ? "turbolinks:load" : "DOMContentLoaded"

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let chat_token = urlParams.get('w2ctoken')
let openChat = urlParams.get('open_chat')

if (openChat) {
  store.dispatch('chatActivated', true)
}

if (chat_token) {
  store.dispatch('loadMessagesFromToken', chat_token)
} else if (localStorage.getItem('chat_id')) {
  store.dispatch('loadMessages', localStorage.getItem('chat_id'))
}

let chat_btn = document.querySelector('#w2c_chat_btn')

if (chat_btn) {
  chat_btn.addEventListener('click', function() {
    store.dispatch('chatActivated')
  })
}

let domain = ''
if(w2c_settings.env === "development") {
  domain = 'http://api.lvh.me:3000'
} else {
  domain = 'https://api.welcometocollege.com'
}

let user_or_group = ''
if (w2c_settings.user) {
  user_or_group = w2c_settings.user
} else if (w2c_settings.group) {
  user_or_group = w2c_settings.group
}


// console.log(process.env.WEBSOCKET_HOST)

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: 'all',
  connectImmediately: false,
  store
});

document.addEventListener(event, () => {
  store.dispatch('checkAppearance', user_or_group)

  const el = document.body.appendChild(document.createElement('w2c_chat'))
  const chat = new Vue({
    el,
    store,
    render: h => h(Chat)
  })

})
